import { Controller } from "@hotwired/stimulus"

// Fisarmonica (Radix Accordion, type="single" collapsible): un elemento aperto per volta.
export default class extends Controller {
  static targets = ["item"]
  static values = { multiple: Boolean }

  toggle(event) {
    const item = event.currentTarget.closest("[data-accordion-target='item']")
    const opening = item.dataset.state !== "open"
    if (!this.multipleValue) this.itemTargets.forEach((i) => this.setState(i, false))
    this.setState(item, opening)
  }

  setState(item, open) {
    const state = open ? "open" : "closed"
    item.dataset.state = state
    item.querySelectorAll("[data-accordion-part]").forEach((el) => (el.dataset.state = state))
    const content = item.querySelector("[data-accordion-part='content']")
    if (content) content.hidden = !open
    item.querySelector("button[aria-expanded]")?.setAttribute("aria-expanded", String(open))
  }
}
